/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

(function () {
'use strict';

angular.module('bulbApp.groupModule')
  .controller('GoogleClassroomImportController', ['$state','BulbBusyService','BulbGroupService','BulbGoogleClassroomImportService', GoogleClassroomImportController]);

function GoogleClassroomImportController($state, BulbBusyService, BulbGroupService, BulbGoogleClassroomImportService) {

  var that = this;
  /**
   * Select class to import from google classroom.
   * @type {class|object}
   */
  this.importGroup = null;

  /**
   * List of classes fetched from google classroom for educator.
   * @type {Array|courses}
   */
  this.classList = BulbGoogleClassroomImportService.courses;

  /**
   * Import selected class from google classroom and create group into bulb.
   */
  this.importClassroomGroup = function () {
    var group = {
      id: that.importGroup.id,
      name: that.importGroup.name,
      description: that.importGroup.descriptionHeading,
      ownerId: that.importGroup.ownerId,
      ownerEmail: that.importGroup.ownerEmail
    };
    BulbBusyService.showBusyDuring(
      BulbGroupService.createClassroomGroup(group, BulbGoogleClassroomImportService.oauthToken)
        .then(function (group) {
          // navigate to group page, with animations
          $state.go('group', {groupUrl: group.url}, {location: 'replace'});
        }, function (error) {
          BulbGoogleClassroomImportService.showError(error);
        })
    );
  };
}
})();
